import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "add-variable-table-content" }
const _hoisted_2 = { class: "add-variable-table-content__calculate-summary calculate-summary" }
const _hoisted_3 = { class: "calculate-summary__title" }
const _hoisted_4 = { class: "calculate-summary__calculate-zone calculate-zone" }
const _hoisted_5 = { class: "calculate-zone__input-formula" }
const _hoisted_6 = {
  key: 0,
  class: "calculate-zone__input-formula--error"
}
const _hoisted_7 = {
  key: 1,
  class: "calculate-zone__input-formula--empty"
}
const _hoisted_8 = { class: "calculate-summary__number-inputs number-inputs" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "calculate-summary__operators operators" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "add-variable-table-content__table-headers table-headers" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "add-variable-table-content__button-area button-area" }

import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useAddVariableTableContentStore } from './useAddVariableTableContentStore';
import { getDisplayNumbers } from '../domains/valueObjects/NumberInput';
import { getDisplayOperator } from '../domains/valueObjects/Operator';
import { getOperators } from '../domains/valueObjects/Operator';
import { getNumberInputs } from '../domains/valueObjects/NumberInput';

import { onUnmounted } from 'vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { TableProperty } from '@/coreDomainsModule/table';

/**
 * props
 * @param useTableHeader - テーブルヘッダ
 */
type Props = {
  tableType: string;
  isEdit?: boolean;
  variableContent?: TableProperty;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tableType: {},
    isEdit: { type: Boolean, default: false },
    variableContent: { default: undefined }
  },
  emits: ["onSuccess", "onError", "onDeleteSuccess", "onDeleteError"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const inventoryStore = useAddVariableTableContentStore();
const { state } = storeToRefs(inventoryStore);
const {
  initState,
  $reset,
  addNumberInput,
  addOperator,
  addHeader,
  allResetCalculate,
  backCalculate,
  saveCalculate,
  deleteCalculate,
  displayFormula,
} = inventoryStore;

onMounted(() => {
  initState(props.tableType, props.isEdit, props.variableContent);
});

// TODO: baseStoreみたいなの作って、全store継承必須にしてこいつ呼ばせるの強制させたい
onUnmounted(() => {
  $reset();
});

const title = computed({
  /**
   * getter
   */
  get: () => state.value.formulaTitle,
  /**
   * setter
   * @param value - タイトル
   */
  set: (value) => {
    inventoryStore.updateState({
      formulaTitle: value,
    });
  },
});

const isAvailableSave = computed(() => {
  return state.value.formulaTitle !== '' && state.value.isValid && state.value.inputFormula.length !== 0;
});

/**
 * 保存処理
 */
const dispatchSaveCalculate = async () => {
  const res = await saveCalculate();
  if (res.type === 'success') {
    emits('onSuccess');
  } else if (res.type === 'error') {
    emits('onError');
  }
};

/**
 * 削除処理
 */
const dispatchDeleteCalculate = async () => {
  const res = await deleteCalculate(state.value.variableContent?.customFormulaId);
  if (state.value.variableContent?.customFormulaId === undefined) {
    emits('onDeleteError');
    return;
  }
  if (res.type === 'success') {
    emits('onDeleteSuccess', state.value.variableContent.customFormulaId);
  } else if (res.type === 'error') {
    emits('onDeleteError');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
          class: "calculate-summary__title--input",
          placeholder: 'タイトルを入力してください'
        }, null, 512), [
          [_vModelText, title.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_unref(displayFormula)(_unref(state).inputFormula)), 1),
        (!_unref(state).isValid && _unref(state).inputFormula.length != 0)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_6, "実行不可能な式です"))
          : (_openBlock(), _createElementBlock("h3", _hoisted_7))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getNumberInputs)(), (numberInput) => {
          return (_openBlock(), _createElementBlock("div", { key: numberInput }, [
            _createElementVNode("h3", {
              class: "number-inputs__number",
              onClick: ($event: any) => (_unref(addNumberInput)(numberInput))
            }, _toDisplayString(_unref(getDisplayNumbers)(numberInput)), 9, _hoisted_9)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getOperators)(), (operator) => {
          return (_openBlock(), _createElementBlock("div", { key: operator }, [
            _createElementVNode("h3", {
              class: "operators__operator",
              onClick: ($event: any) => (_unref(addOperator)(operator))
            }, _toDisplayString(_unref(getDisplayOperator)(operator)), 9, _hoisted_11)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).tableContentHeaders, (header) => {
        return (_openBlock(), _createElementBlock("div", {
          key: header.headerKey
        }, [
          _createElementVNode("h3", {
            class: "table-headers__header",
            onClick: ($event: any) => (_unref(addHeader)(header.headerKey))
          }, _toDisplayString(header.headerName), 9, _hoisted_13)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "button-area__all-reset",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(allResetCalculate) && _unref(allResetCalculate)(...args)))
      }, "やりなおし"),
      _createElementVNode("button", {
        class: "button-area__back",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(backCalculate) && _unref(backCalculate)(...args)))
      }, "１つ戻る"),
      _createVNode(TextButton, {
        color: "primary",
        disabled: !isAvailableSave.value,
        size: 'btn-md',
        class: "button-area__confirm",
        onClick: dispatchSaveCalculate
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(_toDisplayString('この条件で追加'))
        ]), undefined, true),
        _: 1,
        __: [3]
      }, 8, ["disabled"]),
      (_unref(state).isEdit)
        ? (_openBlock(), _createBlock(TextButton, {
            key: 0,
            color: "primary",
            "button-style": 'btn-error',
            size: 'btn-md',
            class: "button-area__confirm",
            onClick: dispatchDeleteCalculate
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(_toDisplayString('このプロパティを削除'))
            ]), undefined, true),
            _: 1,
            __: [4]
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})